import { createDispatchHook, createSelectorHook } from 'react-redux'
import RootStoreContext from 'reduxes/stores/root_store/context'

export const useSelectorDelegateStore = createSelectorHook(RootStoreContext)
export const useDispatchDelegateStore = createDispatchHook(RootStoreContext)
